export default "__VITE_ASSET__CFa2$mCm__"